<template>
  <transition name="fade">
    <v-card>
      <v-card-text>
        <v-form @submit.prevent="checkForm">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="serie"
                label="Serie de factura"
                placeholder="Número Factura"
                :error-messages="errors.serieFactura"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="folio"
                label="Folio de factura"
                placeholder="Folio Factura"
                :error-messages="errors.numeroFactura"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="proveedor"
                :items="comp_prov"
                label="Seleccione un proveedor del listado"
                placeholder="Seleccione un proveedor"
                @update:search="searchProveedor"
                :error-messages="errors.proveedor"
                required
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-btn color="primary" @click="showModalPro = true">
                ¿No encuentras tu proveedor? Agregar
              </v-btn>
            </v-col>

            <v-col cols="12" class="text-right">
              <v-btn color="error" @click="$emit('toggle', false)">
                Cancelar
              </v-btn>
              <v-btn color="success" type="submit"> Guardar </v-btn>
            </v-col>
          </v-row>

          <modal
            v-model="showModalPro"
            :showFooter="false"
            title="Agregar nuevo proveedor"
          >
            <ProveedorForm
              :key="keyformProv"
              @successData="saveProv"
              @toggle="showModalPro = false"
            ></ProveedorForm>
          </modal>
        </v-form>

        <!-- <form v-if="false" class="ui form" @submit="checkForm">
          <div class="field required">
            <label
              >Serie de factura
              <div
                v-if="errors.serieFactura"
                class="ui left pointing red basic label"
              >
                {{ errors.serieFactura }}
              </div>
            </label>
            <input type="text" v-model="serie" placeholder="Numero Factura" />
          </div>
          <div class="field required">
            <label
              >Folio de factura
              <div
                v-if="errors.numeroFactura"
                class="ui left pointing red basic label"
              >
                {{ errors.numeroFactura }}
              </div>
            </label>
            <input type="text" v-model="folio" placeholder="Folio Factura" />
          </div>
          <div class="field two fields">
            <div class="field required">
              <label
                >Seleccione un proveedor del listado
                <div
                  v-if="errors.proveedor"
                  class="ui left pointing red basic label"
                >
                  {{ errors.proveedor }}
                </div>
              </label>
              <model-select
                :options="comp_prov"
                v-model="proveedor"
                @searchchange="searchProveedor"
                placeholder="Seleccione un proveedor"
              >
              </model-select>
            </div>
            <div class="field">
              <label>¿No encuentras tu proveedor?</label>
              <button
                type="button"
                @click="showModalPro = true"
                class="ui primary tiny button"
              >
                Agregar
              </button>
            </div>
          </div>

          <button style="float: right" class="ui button positive" type="submit">
            Guardar
          </button>
          <button
            style="float: right"
            @click="$emit('toggle', false)"
            class="ui button"
            type="button"
          >
            Cancelar
          </button>
          <modal
            v-model="showModalPro"
            :showFooter="false"
            title="Agregar nuevo proveedor"
          >
            <ProveedorForm
              :key="keyformProv"
              @successData="saveProv"
              @toggle="showModalPro = false"
            ></ProveedorForm>
          </modal>
        </form> -->
      </v-card-text>
    </v-card>
  </transition>
</template>

<style>
.select2-container {
  width: 100% !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
import modal from "../../MainComponents/modal.vue";
import { ModelSelect } from "vue-search-select";
import ProveedorForm from "../Proveedores/ProveedoresForm";

export default {
  name: "FacturaForm",
  components: {
    modal,
    ProveedorForm,
    // ModelSelect,
  },
  props: ["edit", "dataEdit", "loadData"],
  data() {
    return {
      searchText: "",
      proveedorNombre: "",
      keyformProv: 1,
      proveedor: " ",
      factura: "",
      serie: "",
      folio: "",
      showModalPro: false,
      errors: {},
      loader: true,
      facturas: [],
      proveedorArray: [],
    };
  },
  methods: {
    async searchProveedor(searchText) {
      if (searchText != "") {
        this.proveedorArray = [];
        searchText = searchText.toUpperCase();
        const database = this.$store.getters.getFirebaseApp.database;
        const data = await database.queryBuilder("AMC/Provedores", []);

        if (data.exists()) {
          let arrayFactura = Object.entries(data.val());
          this.$pgsHelper.log(arrayFactura);
          arrayFactura.forEach((element) => {
            this.proveedorArray.push({
              id: element[0],
              Nombre: element[1]["nom"],
            });
          });
        }
      }

      /*let categorias = [];
        arrayCate.forEach(function(element){
            categorias.push({id:element[0],Nombre:element[1]['Nombre']}); 
        });
        this.Categories = categorias;*/
      //CONF/Catalogo/PDV/Productos/Facturas
    },
    getDetail(productoId) {
      let producto = this.getProductoById(productoId);
      this.actualExist = producto.Existencia;
      this.nombre = producto.Nombre;
      this.actualPrice = producto.Precio;
      this.newPrice = producto.Precio;
      this.codigo = producto.Codigo;
      this.actualMoneda = producto.Moneda;
    },
    getProductoById(code) {
      let itemIndex = this.$_.findIndex(this.products, { id: code });
      if (itemIndex >= 0) {
        return this.products[itemIndex];
      }

      return false;
    },
    saveProv(datos) {
      let sendData = {
        nom: datos.proveedor,
        rfc: datos.rfc,
        coe: null,
        dps: datos.dps,
        tlf: null,
      };
      this.$pgsHelper.log(sendData);
      this.$swal({
        title: "¿Deseas crear este nuevo proveedor?",
        text: "Se registrara el proveedor con los datos indicados ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AMC-Provedores-createProvedor", sendData)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "La factura se guardo corretamente",
              icon: "success",
            });

            this.showModalPro = false;
          } else {
            this.$swal(
              "Error saving Proveedor",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (!this.serie) {
        this.errors.serieFactura = "El serie de factura es obligatorio";
        valid = false;
      } else {
        this.errors.serieFactura = false;
      }

      if (!this.folio) {
        this.errors.numeroFactura = "El folio de factura es obligatorio";
        valid = false;
      } else {
        this.errors.numeroFactura = false;
      }

      if (this.proveedor == " ") {
        this.errors.proveedor = "El proveedor es obligatorio";
        valid = false;
      } else {
        this.errors.proveedor = false;
      }

      /*
        if (!this.HoraFinal) {
            this.errors.hfinal = 'La hora final es requerida';
            valid = false;
        }else{
            this.errors.hfinal = false;
        }*/

      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.proveedorArray.forEach((element) => {
          if (element.id == this.proveedor) {
            this.proveedorNombre = element.Nombre;
          }
        });
        this.factura = this.serie + "-" + this.folio;
        this.$emit("successData", this.$data, doAction);
      }
    },
  },
  computed: {
    comp_fact() {
      let prod = [
        { id: " ", text: "Seleccione una factura" },
        { id: "535435435", text: "10000 - MR MECHANIC PRO" },
        { id: "535435467", text: "20005 - NIKE" },
        { id: "5354354675", text: "30007 - ADIDAS" },
      ];

      return prod;
    },

    comp_prov() {
      let prov = [];
      this.proveedorArray.forEach((element) => {
        prov.push({ value: element.id, text: element.Nombre });
      });

      return prov;
    },
  },
  watch: {
    producto: function (val) {
      this.getDetail(val);
    },
  },
  beforeMount: function () {},
  mounted() {
    this.loader = false;
    if (this.edit) {
      this.nombre = this.dataEdit.Nombre;
    }
    if (this.loadData) {
      this.producto = this.loadData.ProductoId;
    }
  },
};
</script>
